import InfoBox from 'components/InfoBox';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';

const InfoBoxWrapper = styled(Flex)`
  margin-bottom: 0.5rem;
  width: 23.3rem;
`;

export const StyledNoDataInfoBox = ({ children }) => {
  return (
    <InfoBoxWrapper>
      <InfoBox
        iconAlign='center'
        padding='x-small'
        mt='none'
        borderColor='orangePeel'
        backgroundColor='orangePeel'
        borderAlpha={0.3}
        backgroundAlpha={0.1}
        iconColor='orangePeel'
      >
        {children}
      </InfoBox>
    </InfoBoxWrapper>
  );
};
